/* common.js */

$(function () {
  const SECTION_SELECTOR = '#section-content-5';
  const GRID_SELECTOR = '.homepage__section-content-cena';
  const BTN_SELECTOR = '.js-show-more-references';

  const DESKTOP_INITIAL = 9;
  const DESKTOP_STEP = 6;

  const MOBILE_INITIAL = 4;
  const MOBILE_STEP = 4;

  function isDesktop() {
    // Tailwind "lg" = 1024px
    return window.matchMedia('(min-width: 768px)').matches;
  }

  function getCfg() {
    return isDesktop()
      ? { initial: DESKTOP_INITIAL, step: DESKTOP_STEP }
      : { initial: MOBILE_INITIAL, step: MOBILE_STEP };
  }

  function setupGrid($grid) {
    const $btn = $grid.find(BTN_SELECTOR).first();
    if (!$btn.length) return;

    const $btnRow = $btn.closest('div'); // wrapper tlačítka v gridu
    const $items = $grid.children('div').not($btnRow); // pouze reference, ne tlačítko

    if (!$items.length) {
      $btnRow.hide();
      return;
    }

    function applyShownCount(shownCount, animate) {
      $items.each(function (idx) {
        const $el = $(this);
        const shouldShow = idx < shownCount;

        if (animate) {
          shouldShow ? $el.stop(true, true).slideDown(200) : $el.stop(true, true).slideUp(200);
        } else {
          $el.toggle(shouldShow);
        }
      });
    }

    function reset() {
      const cfg = getCfg();
      const total = $items.length;

      const shown = Math.min(cfg.initial, total);
      $grid.data('shownCount', shown);

      applyShownCount(shown, false);

      if (total > shown) {
        $btnRow.show(200);
      } else {
        $btnRow.hide(200);
      }
    }

    function showMore() {
      const cfg = getCfg();
      const total = $items.length;

      const currentShown = Number($grid.data('shownCount')) || Math.min(cfg.initial, total);
      const nextShown = Math.min(currentShown + cfg.step, total);

      $grid.data('shownCount', nextShown);

      $items.each(function (idx) {
        if (idx < nextShown) {
          $(this).stop(true, true).slideDown(200);
        }
      });

      if (nextShown >= total) {
        $btnRow.hide();
      }
    }

    // klik na existující tlačítko v HTML
    $btn.off('click.references').on('click.references', function (e) {
      e.preventDefault();
      showMore();
    });

    // init
    reset();

    // resize -> přepočet podle breakpointu (pracovní chování)
    let t;
    $(window).off('resize.references').on('resize.references', function () {
      clearTimeout(t);
      t = window.setTimeout(reset, 150);
    });

    // při otevření sekce (aria-hidden: true -> false) udělej reset
    const contentEl = document.querySelector(SECTION_SELECTOR);
    if (contentEl && !contentEl.__refsObserverAttached) {
      const obs = new MutationObserver(function (mutList) {
        for (const m of mutList) {
          if (m.type === 'attributes' && m.attributeName === 'aria-hidden') {
            const hidden = contentEl.getAttribute('aria-hidden') === 'true';
            if (!hidden) reset();
          }
        }
      });
      obs.observe(contentEl, { attributes: true, attributeFilter: ['aria-hidden'] });
      contentEl.__refsObserverAttached = true;
    }
  }

  const $section = $(SECTION_SELECTOR);
  if (!$section.length) return;

  $section.find(GRID_SELECTOR).each(function () {
    setupGrid($(this));
  });
});


$(function () {
  if (typeof GLightbox !== 'function') return;

  window.referencesLightbox = GLightbox({
    selector: '.js-ref-lightbox',
    touchNavigation: true,
    loop: false,
    closeButton: true,
  });
});
